import React from 'react';
import {atom} from 'jotai';

import {IJobPosition} from '../models/IJobPosition';

export const positionsAtom = atom<IJobPosition[]>([]);
export const dashboardPositionAtom = atom<IJobPosition | null>(null);
